
import { requestMutations, requestQueries } from './request';
import { invitationMutations } from './invitation';
import { purchaseRequestMutations } from './purchaseRequest';
import { catalogMutations } from './catalog';
// Export all hub queries
export const hubQueries = {
  request: requestQueries,
  // Uncomment as we implement each domain
  // project: projectQueries,
  // analytics: analyticsQueries,
};

// Export all hub mutations
export const hubMutations = {
  request: requestMutations,
  invitation: invitationMutations,
  purchaseRequest: purchaseRequestMutations,
  catalog: catalogMutations,
};

